/**
 * מזהה אקראי לשמות קבצים באחסון.
 *
 * crypto.randomUUID קיים רק בהקשר מאובטח — HTTPS או localhost.
 * כשפותחים את האפליקציה בטלפון מול שרת הפיתוח שברשת הביתית
 * (http://192.168.x.x) הוא פשוט אינו מוגדר, וכל העלאת תמונה
 * נפלה שם על TypeError שהוצג כ"משהו השתבש".
 *
 * crypto.getRandomValues לעומתו זמין גם בהקשר לא מאובטח, ולכן
 * הגיבוי בונה ממנו UUID v4 תקני. זו אינה פשרה באקראיות: אותו
 * מקור אקראיות בדיוק, רק בלי הפונקציה שעוטפת אותו.
 */
export function newId(): string {
  if (typeof crypto?.randomUUID === 'function') return crypto.randomUUID();

  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);

  // גרסה 4 וביטי הווריאנט, לפי RFC 4122
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
